export const formatDateToDatepicker = (
  date: string | undefined
): { year: number; month: number; day: number } | undefined => {
  if (date) {
    const dateArray = date.split('-');
    return {
      year: +dateArray[0],
      month: +dateArray[1],
      day: +dateArray[2],
    };
  }

  return;
};

export const formatDateToDatepickerCopy = (
  date: string | undefined
): { year: number; month: number; day: number } | undefined => {
  if (date) {
    const dateArray = date.split('-');
    return {
      year: +dateArray[0],
      month: +dateArray[1],
      day: +dateArray[2],
    };
  }

  return;
};

export const formatDateFromPicker = (date: {
  year: string;
  day: string;
  month: string;
}) => {
  return `${date.year}-${date.month}-${date.day}`;
};

export const formatTimeFromPicker = (time: {
  hour: string;
  minute: string;
}) => {
  return `${time.hour}:${time.minute}`;
};

export const formatTimeToDatepicker = (
  time: string | undefined
): { hour: number; minute: number } | undefined => {
  if (time) {
    const dateArray = time.split(':');
    return {
      hour: +dateArray[0],
      minute: +dateArray[1],
    };
  }

  return;
};

export const formatDateTimeToDatepicker = (datetime: string) => {
  const date = new Date(datetime);
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
    hour: date.getHours(),
    minute: date.getMinutes(),
  };
};

export const timeToLocalForDatepicker = (datetime: string) => {
  return new Date(datetime).toLocaleTimeString();
};

export const formatDateTimeFromDatepicker = (
  date: { year: string; day: string; month: string },
  time: { hour: string; minute: string }
) => {
  return new Date(
    +date.year,
    +date.month - 1,
    +date.day,
    +time.hour,
    +time.minute
  ).toISOString();
};

export const formatDatePicker = (date: {
  year: number;
  date: number;
  month: number;
}) => {
  let day = date.date.toString();
  let month = (date.month + 1).toString();

  if (day.length === 1) {
    day = '0' + date.date;
  }

  if (month.length === 1) {
    month = '0' + month;
  }

  return `${date.year}-${month}-${day}`;
};

export const formatDateTimeToIso = (date: string, time: string) => {
  const dateArr = date.split('-');
  const timeArr = time.split(':');
  return new Date(
    +dateArr[0],
    +dateArr[1] - 1,
    +dateArr[2],
    +timeArr[0],
    +timeArr[1]
  );
};

export const formattedDateWithMinutesSecond = (date: Date): string => {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  const seconds = ('0' + date.getSeconds()).slice(-2);

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};
